// D-1085 案 1: 「不具合・要望」のシートを開く合図。
//   ★shared は shared しか import できない(eslint-plugin-boundaries)。シートの本体(components/FeedbackSheet)は
//     App に 1 つだけ置いた components/FeedbackHost が持ち、ここは「開いて」を伝えるだけ。依存なし。
//   ★ほかの画面からも呼べる: openFeedback() / openFeedback({ storeCode })。storeCode を渡すとそれを優先し、
//     渡さなければ FeedbackHost が今の pathname から店を決める。route は送るときの pathname(FeedbackSheet)。
//   ★受け手(FeedbackHost)が居ないとき(ログイン前など)は hasFeedbackHost() が false。入口はそのとき出さない。

const listeners = new Set()

/** FeedbackHost が受け手として登録する。戻り値で外す。 */
export function subscribeFeedback(fn) {
  listeners.add(fn)
  return () => { listeners.delete(fn) }
}

/** 受け手が居るか(= 押せば開くか)。 */
export function hasFeedbackHost() {
  return listeners.size > 0
}

/**
 * 不具合・要望のシートを開く。
 * @param {{ storeCode?: string|null }} [opts]
 * @returns {boolean} 受け手が居て合図を出せたら true
 */
export function openFeedback(opts = {}) {
  if (listeners.size === 0) return false
  const req = { storeCode: opts.storeCode ?? null }
  listeners.forEach(fn => fn(req))
  return true
}
